export default __webpack_public_path__ + "static/media/image-sign.f582dd07.png";